import React from 'react';
import PropTypes from 'prop-types';

const SyncConfirmModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex justify-center items-center">
      <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 md:mx-0 p-6">
        <div className="mb-4">
          <h3 className="text-lg font-medium text-gray-900 mb-2">Sync Meta Leads</h3>
          <p className="text-sm text-gray-600">
            Choose how to handle existing leads during the sync:
          </p>
        </div>
        
        <div className="space-y-3 mb-6">
          <div className="p-3 border border-gray-200 rounded-md hover:bg-gray-50 cursor-pointer"
               onClick={() => onConfirm(false)}>
            <h4 className="font-medium">Add new leads only</h4>
            <p className="text-sm text-gray-600">Only import leads that don't exist in your CRM yet.</p>
          </div>
          
          <div className="p-3 border border-blue-200 bg-blue-50 rounded-md hover:bg-blue-100 cursor-pointer"
               onClick={() => onConfirm(true)}>
            <h4 className="font-medium text-blue-800">Update all leads</h4>
            <p className="text-sm text-gray-600">Import new leads and update information for existing leads.</p>
          </div>
        </div>
        
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-white text-gray-700 border border-gray-300 rounded-md shadow-sm hover:bg-gray-50"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

SyncConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default SyncConfirmModal;